import { render, staticRenderFns } from "./CustomersWalletCard.vue?vue&type=template&id=4999a356&scoped=true"
import script from "./CustomersWalletCard.vue?vue&type=script&lang=js"
export * from "./CustomersWalletCard.vue?vue&type=script&lang=js"
import style0 from "./CustomersWalletCard.vue?vue&type=style&index=0&id=4999a356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4999a356",
  null
  
)

export default component.exports